export const SET_MEMBERSHIPS = 'SET_MEMBERSHIPS';
export const FETCH_MEMBERSHIP_TRX = 'FETCH_MEMBERSHIP_TRX';
export const SET_STATS = 'SET_STATS';
export const SET_INVOICE_RESERVATION = 'SET_INVOICE_RESERVATION';
